import React from "react";
import "../../assets/css/skeleton.css";

export default function ListSkeleton() {
  return (
    <div className="card border-0">
      <div class="container loading-skeleton">
        <div class="row gy-3">
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
          <div class="col-md-4">
            <div class="card bg-light"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
